import React, { useState } from 'react'
import avatar1 from "../../assets/img/xs/avatar1.jpg";
import avatar2 from "../../assets/img/xs/avatar2.jpg"
import avatar3 from "../../assets/img/xs/avatar3.jpg"
import avatar4 from "../../assets/img/xs/avatar4.jpg"
import avatar5 from "../../assets/img/xs/avatar5.jpg"
import avatar6 from "../../assets/img/xs/avatar6.jpg"
import avatar7 from "../../assets/img/xs/avatar7.jpg"
import avatar8 from "../../assets/img/xs/avatar8.jpg"
import project_team from "../../assets/img/project-team.svg"


const MyDashboard = () => {
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 4; // Total number of steps
    const handleTabChange = (step) => setCurrentStep(step);
    const progressBarWidth = (currentStep / totalSteps) * 100;
    const handleCheckboxChange = () =>  setIsChecked(prev => !prev);
    const handleCheckboxChange1 = () => setIsChecked1(prev => !prev);

    return (
        <div className="modal-content rounded-0">
            <div className="modal-header">
                <h5 className="modal-title">Setup new project</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="progress bg-transparent" style={{ height: "3px" }}>
                <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={progressBarWidth} aria-valuemin="0" aria-valuemax="100" style={{ width: `${progressBarWidth}%` }}></div>
            </div>
            <div className="modal-body custom_scroll">
                <ul className="nav nav-tabs tab-card border-0 fs-6" role="tablist">
                    {[1, 2, 3, 4].map(step => (
                        <li key={step} className="nav-item flex-fill text-center">
                            <a
                                className={`nav-link ${currentStep === step ? 'active' : ''}`}
                                href={`#step${step}`}
                                data-bs-toggle="tab"
                                onClick={() => handleTabChange(step)} // Update current step
                            >
                                {step}. {step === 1 ? 'Project' : step === 2 ? 'Team' : step === 3 ? 'File' : 'Completed'}
                            </a>
                        </li>
                    ))}
                </ul>
                <div className="tab-content">
                    <div className={`tab-pane fade ${currentStep === 1 ? 'show active' : ''}`} id="step1">
                        <div className="card mb-2">
                            <div className="card-body">
                                <h6 className="card-title mb-1">Project Type</h6>
                                <p className="text-muted small">If you need more info, please check out <a href="#">FAQ Page</a></p>

                                <div className="c_radio d-flex flex-md-wrap">
                                    <label className="m-1 w-100" htmlFor="Personal">
                                        <input type="radio" name="plan" id="Personal"  checked={isChecked1} // Controlled by state
                                        onChange={handleCheckboxChange1} /> 
                                        <span className="card">
                                            <span className="card-body d-flex p-3">
                                                <svg className="avatar" viewBox="0 0 16 16">
                                                    <path className="fill-muted" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                                </svg>
                                                <span className="ms-3">
                                                    <span className="h6 d-flex mb-1">Personal Project</span>
                                                    <span className="text-muted">For smaller business, with simple salaries and pay schedules.</span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                    <label className="m-1 w-100" htmlFor="Team">
                                        <input type="radio" name="plan" id="Team" />
                                        <span className="card">
                                            <span className="card-body d-flex p-3">
                                                <svg className="avatar" viewBox="0 0 16 16">
                                                    <path className="fill-muted" d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                                    <path className="fill-muted" fillRule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z" />
                                                    <path className="fill-muted" d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                                                </svg>
                                                <span className="ms-3">
                                                    <span className="h6 d-flex mb-1">Team Project</span>
                                                    <span className="text-muted">For growing business who wants to create a rewarding place to work.</span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-2">
                            <div className="card-body">
                                <h6 className="card-title mb-1">Project Details</h6>
                                <p className="text-muted small">It is a long established fact that a reader will be distracted by Luno.</p>
                                <div className="form-floating mb-2">
                                    <select className="form-select" defaultValue={1}>
                                        <option >Open this select menu</option>
                                        <option value="1">Lucid</option>
                                        <option value="2">LUNO</option>
                                        <option value="3">Luno</option>
                                    </select>
                                    <label>Choose a Customer *</label>
                                </div>
                                <div className="form-floating mb-2">
                                    <input type="text" className="form-control" placeholder="Project name" />
                                    <label>Project name *</label>
                                </div>
                                <div className="form-floating mb-2">
                                    <textarea className="form-control" placeholder="Add project details" style={{ height: "100px" }}></textarea>
                                    <label>Add project details</label>
                                </div>
                                <div className="form-floating mb-2">
                                    <input type="date" className="form-control" />
                                    <label>Enter release Date *</label>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="text-muted">Allow Notifications *</div>
                                    <div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="allow_phone" value="option1" />
                                            <label className="form-check-label" htmlFor="allow_phone">Phone</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="allow_email" value="option2" />
                                            <label className="form-check-label" htmlFor="allow_email">Email</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-lg bg-secondary text-light next text-uppercase">Add People</button>
                        </div>
                    </div>
                    <div className={`tab-pane fade ${currentStep === 2 ? 'show active' : ''}`} id="step2">
                        {/* Step 2 content */}
                        <div className="card mb-3">
                            <div className="card-body">
                                <h6 className="card-title mb-1">Build a Team</h6>
                                <p className="text-muted small">If you need more info, please check out <a href="#">Project Guidelines</a></p>
                                <div className="form-floating mb-4">
                                    <input type="text" className="form-control" placeholder="Invite Teammates" />
                                    <label>Invite Teammates</label>
                                </div>
                                <h6 className="card-title mb-1">Team Members</h6>
                                <div className="form-check form-switch">
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id="list-group6"
                                        checked={isChecked} // Controlled by state
                                        onChange={handleCheckboxChange} />
                                    <label className="form-check-label text-muted" htmlFor="list-group6">Adding Users by Team Members</label>
                                </div>
                            </div>
                            <ul className="list-group list-group-flush list-group-custom custom_scroll mb-0" style={{ height: "300px" }}>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar1} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Chris Fox</div>
                                        <small className="text-muted">Angular Developer</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar2} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Joge Lucky</div>
                                        <small className="text-muted">ReactJs Developer</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar3} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Chris Fox</div>
                                        <small className="text-muted">NodeJs Developer</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar4} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Chris Fox</div>
                                        <small className="text-muted">Sr. Designer</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar5} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Chris Fox</div>
                                        <small className="text-muted">Designer</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar6} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Chris Fox</div>
                                        <small className="text-muted">Front-End Developer</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar7} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Chris Fox</div>
                                        <small className="text-muted">QA</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                                <li className="list-group-item d-flex align-items-center">
                                    <img className="avatar rounded" src={avatar8} alt="" />
                                    <div className="flex-fill ms-2">
                                        <div className="h6 mb-0">Chris Fox</div>
                                        <small className="text-muted">Laravel Developer</small>
                                    </div>
                                    <select className="form-select rounded-pill form-select-sm w120" defaultValue={1}>
                                        <option value="1">Owner</option>
                                        <option value="2">Can Edit</option>
                                        <option value="3">Guest</option>
                                    </select>
                                </li>
                            </ul>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-lg bg-secondary text-light next text-uppercase">Select Files</button>
                        </div>
                    </div>
                    <div className={`tab-pane fade ${currentStep === 3 ? 'show active' : ''}`} id="step3">
                        <div className="card mb-3">
                            <div className="card-body">
                                <h6 className="card-title mb-1">Upload Files</h6>
                                <div className="mb-4">
                                    <label className="form-label small">Upload up to 10 files</label>
                                    <input className="form-control" type="file" multiple />
                                </div>
                                <span>Already Uploaded File</span>
                            </div>
                            <ul className="list-group list-group-flush list-group-custom custom_scroll mb-0" style={{ height: "300px" }}>
                                <li className="list-group-item py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="avatar rounded no-thumbnail"><i className="fa fa-file-pdf-o text-danger"></i></div>
                                        <div className="flex-fill ms-3 text-truncate">
                                            <p className="mb-0 color-800">Annual Sales Report 2018-19</p>
                                            <small className="text-muted">.pdf, 5.3 MB</small>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="avatar rounded no-thumbnail"><i className="fa fa-file-excel-o text-success"></i></div>
                                        <div className="flex-fill ms-3 text-truncate">
                                            <p className="mb-0 color-800">Complete Product Sheet</p>
                                            <small className="text-muted">.xls, 2.1 MB</small>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="avatar rounded no-thumbnail"><i className="fa fa-file-word-o text-info"></i></div>
                                        <div className="flex-fill ms-3 text-truncate">
                                            <p className="mb-0 color-800">Marketing Guidelines</p>
                                            <small className="text-muted">.doc, 2.3 MB</small>
                                        </div>
                                    </div>
                                </li>
                                <li className="list-group-item py-3">
                                    <div className="d-flex align-items-center">
                                        <div className="avatar rounded no-thumbnail"><i className="fa fa-file-zip-o"></i></div>
                                        <div className="flex-fill ms-3 text-truncate">
                                            <p className="mb-0 color-800">Brand Photography</p>
                                            <small className="text-muted">.zip, 30.5 MB</small>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-lg bg-secondary text-light next text-uppercase">Advanced Options</button>
                        </div>
                    </div>
                    <div className={`tab-pane fade ${currentStep === 4 ? 'show active' : ''}`} id="step4">
                        <div className="card text-center">
                            <div className="card-body">
                                <h4 className="card-title mb-1">Project Created!</h4>
                                <span className="text-muted">If you need more info, please check how to create project</span>
                            </div>
                            <div className="card-body">
                                <button className="btn btn-lg bg-light first text-uppercase">Cretae new project</button>
                                <button className="btn btn-lg bg-secondary text-light text-uppercase">View project</button>
                            </div>
                            <div className="card-body">
                                <img className="img-fluid" src={project_team} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyDashboard;
